import { DateTime } from 'luxon';

export const formatToday = datems => {
  const date = DateTime.fromMillis(datems).toLocaleString();
  return date;
};

export default formatToday;
